<template>
  <div class="revision-history-revision">
    <div class='revision-history-revision__revision-header'>
      {{revisionText}}
    </div>
    <!--Maybe add in a line here that is horizontal, so that we have a change
    or we can use a different share of color to show that there is a change in the seperation of information-->
    <div class='revision-history-revision__footer'>
      <span>
        <span class='revision-history-revision__audience'>
          <!--Now we need to show the UE and the change in the UE from the previous one
              1. if the change is positive I want a Black circle with a Green plus sign
              2. if the change is negative I want a Black circle witha Red Minus sign-->
              {{totalAudience}}
              <!--Maybe we will need a Vertical space around here to seperate the two-->
        </span>
        <template v-if="!isCurrentRevision">
          <positiveity-indicator
            :number='changeInAudience'
            :message='changeInAudienceMessage'>
          </positiveity-indicator>
          <oval-button
            class="revision-history-revision__goto"
            @click.native="goto">
            GOTO
          </oval-button>
        </template>
      </span>
    </div>
  </div>
</template>

<script>
import {PositiveityIndicator} from '@/components/common/positiveityIndicator'
import {smallNumber} from '@/helpers'
import {OvalButton} from '@/components/common/ovalLabel'
/**
 * 1. we need a way to display the sections
 *  A. Branches
 *  B. Revision Histories on the branch
 * ok now I did not think about the way the branches would be displayed but that is ok....
 */
// we want the revision to show the total audience
// we want it to show the difference of the current and the revision
export default {
  components: {
    PositiveityIndicator,
    OvalButton
  },
  props: {
    move: {
      type: Number,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    target_data: {
      type: Object,
      required: true
    },
    currentAudience: {
      type: Number,
      default: 0
    },
    isCurrentRevision: {
      type: Boolean,
      default: false
    },
    goto: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    audience () {
      return this.target_data.audienceSize
    },
    totalAudience () {
      return 'Total Audience: ' + smallNumber(String(this.audience))
    },
    revisionText () {
      return 'Move ' + String(this.move) + ': ' + this.label
    },
    changeInAudience () {
      return this.audience - this.currentAudience
    },
    changeInAudienceMessage () {
      return smallNumber(String(Math.abs(this.changeInAudience)))
    }
  }
}
</script>

<style lang='scss'>
.revision-history-revision {
  padding-top: 10px;

  &__revision-header {

  }

  &__footer {
    margin-top: 10px;
    margin-bottom: 10px;
  }

  &__audience {
    padding-left: 10px;
    padding-right: 10px;
  }
  &__goto {
    background-color: green;
    margin-left: 15px;
    border-color: green !important;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// RevisionHistory.vue?3a6092fb